export const getCancelTournamentEndpoint = (tournamentId: string) =>
  `/v1/tournaments/${tournamentId}/cancel`;
